class IframeMessageProxyActions {
    static SEND_COMMAND = 'sendCommand';

    static START_LOADING = 'startLoading';

    static STOP_LOADING = 'stopLoading';

    static HEIGHT_CHANGE = 'heightChange';

    static SHOW_MODAL = 'showModal';

    static HIDE_NAVBAR = 'hideNavbar';

    static SHOW_NAVBAR = 'showNavbar';

    static GET_CURRENT_LANGUAGE = 'getCurrentLanguage';

    static TOAST = 'toast';

    static GET_APPLICATION = 'getApplication';

    static HAS_PERMISSIONS = 'hasPermissions';

    static GET_PERMISSIONS_OBJECT = 'getPermissionsObject';

    static GET_USER_CONTEXT = 'getUserContext';
}

export default IframeMessageProxyActions;
